import { Heading3 } from '@src/components/typography/Heading3';
import { Avatar } from '../Avatar';
import { classNames } from '@utils/classNames';
import { Link } from '../Link';

export const Header = ({
  header,
  avatar,
  className,
}: {
  header: string;
  avatar?: string;
  className?: string;
}) => {
  return (
    <span
      className={classNames(
        'flex justify-between items-center',
        'px-4 sm:px-0 gap-2 pt-2 sm:pt-0',
        className,
      )}
    >
      <Heading3>{header}</Heading3>
      <Link href={'/profile'} className="sm:hidden">
        <Avatar disabled type="directusFile" asset={avatar} size="small" />
      </Link>
    </span>
  );
};
